import script from "./ParticipantsTableAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantsTableAdmin.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantsTableAdmin.vue?vue&type=style&index=0&id=58a317a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a317a8"]])

export default __exports__